import api from './api';

export const badgeService = {
  // Get all available badges
  async getAllBadges() {
    const response = await api.get('/badges');
    return response.data;
  },

  // Student: Get my badges (earned and available)
  async getMyBadges() {
    const response = await api.get('/badges/me');
    return response.data;
  },

  // Student: Get my certificates
  async getMyCertificates() {
    const response = await api.get('/badges/me/certificates');
    return response.data;
  },

  // Teacher: Get student's badges
  async getStudentBadges(studentId) {
    const response = await api.get(`/badges/student/${studentId}`);
    return response.data;
  },

  // Teacher: Award badge to student
  async awardBadge(studentId, badgeId) {
    const response = await api.post('/badges/award', null, {
      params: { student_id: studentId, badge_id: badgeId },
    });
    return response.data;
  },

  // Teacher: Get student's certificates
  async getStudentCertificates(studentId) {
    const response = await api.get(`/badges/certificates/${studentId}`);
    return response.data;
  },

  // Teacher: Generate certificate for student
  async generateCertificate(studentId, type, title = null) {
    const response = await api.post('/badges/certificates/generate', {
      student_id: studentId,
      type,
      title,
    });
    return response.data;
  },
};

export default badgeService;
